import React, {Component} from 'react'
import { Container } from './index'

import { Editor, EditorContext  } from '@atlaskit/editor-core'


export default class wikiEditor extends Component {

    onChange = (editorView) => {
      let props = this.props      
      let contents = editorView.state.doc      
      if (props.onChange) {
        props.onChange(contents)
      }
    };


    handleSave = (editorView) => {
      let { onSave } = this.props
      let contents = editorView.state.doc      
      onSave(contents)
    }

    render () {
      let { onCancel, value, onSave, mentionProvider, disabled } = this.props      
      return (
        <Container>        
          <EditorContext>
            <div>                
                <Editor appearance="comment"
                    isExpandedByDefault 
                    allowRule={true}
                    allowTextFormatting={true}
                    allowCodeBlocks={true}
                    allowTextColor={true}
                    allowLists={true}
                    allowTables={true}
                    mentionProvider={mentionProvider}
                    onSave={onSave ? this.handleSave : null}
                    onCancel={onCancel ? onCancel : null}
                    onChange={this.onChange}
                    defaultValue={value ? value : null}
                    disabled={disabled ? disabled : false}
                    />
            </div>
          </EditorContext>
        </Container>
      )
    }    
  }


// WEBPACK FOOTER //
// ./client/src/components/JiraWikiEditor.js